export default {
    namespaced: true,
    state: {
        loading: false,
    },
    mutations: {
        setLoading(state, status) {
            state.loading = status;
        }
    },
    actions: {
        startLoading({ commit }) {
            commit('setLoading', true);
        },
        stopLoading({ commit }) {
            commit('setLoading', false);
        }
    },
    getters: {
        getLoading({ loading }) {
            return loading;
        }
    }
}
